import _lib from '../_lib';
import active from './active/index';
import {UserProfileNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'profile';
  let activations = [
    {
      name: 'profile',
      test: api.messageIs(UserProfileNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};
